/**
 * Utility functions for generating canonical URLs
 */

/**
 * Get the base URL from environment variable or use default
 */
export const getBaseUrl = (): string => {
  return import.meta.env.VITE_BASE_URL || 'https://achecker.ca'
}

/**
 * Generate a canonical URL for a given path
 * @param path - The path to append to the base URL (e.g., '/wcag-validator')
 * @returns The full canonical URL
 */
export const getCanonicalUrl = (path: string = ''): string => {
  const baseUrl = getBaseUrl()

  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  // Remove trailing slash from base URL if it exists
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl

  // For root path, return base URL without trailing slash
  if (normalizedPath === '/') {
    return cleanBaseUrl
  }

  // For other paths, combine base URL with path
  return `${cleanBaseUrl}${normalizedPath}`
}

/**
 * Generate canonical URL for blog posts
 * @param slug - The blog post slug
 * @returns The full canonical URL for the blog post
 */
export const getBlogCanonicalUrl = (slug: string): string => {
  return getCanonicalUrl(`/blog/${slug}`)
}